import React, { FC } from 'react'
import { makeStyles, createStyles, Button, TextField } from '@material-ui/core'
import { Search as SearchIcon } from '@material-ui/icons'

interface Props {
    email: string
    onChangeEmail: (email: string) => void
    onSearch: () => void
}

export const SellerSearch: FC<Props> = ({
    email,
    onChangeEmail,
    onSearch
}) => {
    const styles = useStyles()
    return (
        <div className={styles.container}>
            <div>
                <TextField label="Ingrese mail corporativo" value={email} onChange={(event) => onChangeEmail(event.target.value as string)}/>
            </div>
            <Button variant='text' color='primary' endIcon={<SearchIcon/>} onClick={onSearch}>Buscar</Button>
        </div>
    )
}

const useStyles = makeStyles(
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
        }
    })
)